/* eslint-disable max-len */
export const TABS = [
	{
		value: '1',
		label: 'Security Products',
	},
	{
		value: '2',
		label: 'Private Subscriptions',
	},
];

export const SAFE_ZONE_ID = 3;
export const SAFE_ZONE_PLUS_ID = 6;

export const SECURITY_PRODUCTS_MSG = 'You have very limited security products enabled – did you know we have these options available?';
export const PRIVATE_SUBSCRIPTIONS_MSG = 'You have very limited private subscriptions enabled – did you know we have these options available?';
export const UPSELL_NO_OPTIONS_MSG = 'You have no upsell options available at this time.';
export const UPSELL_NO_USER_MSG = 'No user id is available. Please select a user. And try again.';
export const UPSELL_CONTENT_MSG = 'I noticed you have some important upgrades available for your account. Would you have a minute to quickly let me run through them with while I have you on the phone?';